<template>
  <Row class="line-detail">
    <Row class="judgment-result-text">判决后我方决定</Row>
    <RadioGroup v-model="judgmentResult">
      <Radio
        v-for="result in judgmentResultStatusArr" :key="result.id"
        :label="result.value"
      >{{ result.nameZh }}</Radio>
    </RadioGroup>
    <div>
      <Button
        size="small" type="warning"
        :loading="loading" @click="checkJudgmentResult()"
      >
        <span v-if="!loading">确定</span>
      </Button>
    </div>
  </Row>
</template>

<script>
export default {
  name: 'JudgeResult',
  props: ['processId', 'judgeType'], // 'judgeType': criminal(刑事) civil（民事）
  data () {
    return {
      judgmentResultStatusArr: [],
      judgmentResult: 'E',
      loading: false
    }
  },
  created() {
    this.getDictionary()
  },
  methods: {
    // 数据字典
    async getDictionary() {
      this.judgmentResultStatusArr = await this.common.getDictionaryItems('judgment_result_status')
    },
    // 是否接受判决结果
    checkJudgmentResult() {
      const url = this.judgeType === 'criminal'
        ? `/business/case/criminal/judgment/result?processId=${this.processId}&resultStatus=${this.judgmentResult}`// 刑事
        : `/business/case/judgment/result?processId=${this.processId}&resultStatus=${this.judgmentResult}` // 民事
      this.loading = true
      this.$patch(url).then(res => {
        this.loading = false
        if (res.code === 0) {
          this.$Message.success('操作成功')
          this.$emit('reloadProcess')
        } else {
          this.$Message.error(res.message)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.line-detail {
  padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/civilCase/adjudicate/judgeResult.vue